// src/pages/NextShows.jsx
import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import {
  collection,
  getDocs,
  query,
  where,
  orderBy
} from 'firebase/firestore';
import { Link } from 'react-router-dom';

function NextShows() {
  const [upcomingShows, setUpcomingShows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [typeFilter, setTypeFilter] = useState('all'); // weekly/ple
  const [rosterFilter, setRosterFilter] = useState('all'); // main/extra

  useEffect(() => {
    const fetchShows = async () => {
      try {
        setLoading(true);

        // Recupera solo gli show futuri
        const upcomingQuery = query(
          collection(db, 'shows'),
          where('data', '>', new Date()),
          orderBy('data', 'asc')
        );

        const upcomingSnap = await getDocs(upcomingQuery);

        // Per ogni show futuro, conta i partecipanti e calcola roster da isExtra
        const showsWithCounts = await Promise.all(
          upcomingSnap.docs.map(async (doc) => {
            const showData = doc.data();
            const showId = doc.id;

            // Conta i partecipanti dalla sotto-collezione 'participations'
            const participationsRef = collection(db, 'shows', showId, 'participations');
            const participationsSnap = await getDocs(participationsRef);
            const participantsCount = participationsSnap.size;

            // Calcola roster in base a isExtra (true → extra, false → main)
            const roster = showData.isExtra === true ? 'extra' : 'main';

            return {
              id: showId,
              ...showData,
              date: showData.data?.toDate() || null,
              participantsCount,
              roster, // campo derivato per filtri e badge
            };
          })
        );

        setUpcomingShows(showsWithCounts);
      } catch (error) {
        console.error("Error fetching upcoming shows:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchShows();
  }, []);

  const filteredShows = upcomingShows.filter(show => {
    // Filtro per tipo (weekly/ple)
    let typeMatch = true;
    if (typeFilter !== 'all') {
      typeMatch = show.type === typeFilter;
    }

    // Filtro per roster (main/extra)
    let rosterMatch = true;
    if (rosterFilter !== 'all') {
      rosterMatch = show.roster === rosterFilter;
    }

    return typeMatch && rosterMatch;
  });

  // Estrai roster unici per eventuale filtro dinamico
  const uniqueRosters = [...new Set(upcomingShows.map(show => show.roster))];

  const getTypeBadge = (type) => {
    const badges = {
      'weekly': { class: 'bg-primary', text: 'Settimanale' },
      'weekly-special': { class: 'bg-info', text: 'Speciale TV' },
      'ple': { class: 'bg-brand-secondary text-brand-primary', text: 'PLE' },
      'ple-free': { class: 'bg-purple text-white', text: 'Special' }
    };
    const badge = badges[type] || { class: 'bg-secondary', text: type };
    return <span className={`badge ${badge.class} px-2 py-1`}>{badge.text}</span>;
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(180deg, var(--brand-bg-dark) 0%, #1c2631 100%)',
    }}>
      <div className="shows-container mx-auto py-2">
        {/* HEADER CON TITOLO (SENZA TOGGLE VIEW) */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3 mb-2 mt-3">
          <h1 className="mb-3 fw-bold text-center text-brand-secondary" style={{
            fontFamily: "'Cinzel Decorative'",
            textShadow: '1px 1px 2px rgba(0, 0, 0)'
          }}>

            Prossimi Shows
          </h1>
        </div>

        {/* Filtri Roster (sinistra) 
        <div className="btn-group btn-group-sm">
          <button
            className={`btn btn-sm ${rosterFilter === 'all' ? 'btn-dark' : 'btn-outline-dark'} text-nowrap`}
            onClick={() => setRosterFilter('all')}
          >
            <span className="d-none d-sm-inline">Tutti</span>
            <span className="d-inline d-sm-none"><i className="bi bi-globe"></i></span>
          </button>
          <button
            className={`btn btn-sm ${rosterFilter === 'main' ? 'btn-primary' : 'btn-outline-primary'} text-nowrap`}
            onClick={() => setRosterFilter('main')}
          >
            <span className="d-none d-sm-inline">Main Roster</span>
            <span className="d-inline d-sm-none"><i className="bi bi-house-fill"></i></span>
          </button>
          <button
            className={`btn btn-sm ${rosterFilter === 'extra' ? 'btn-danger' : 'btn-outline-danger'} text-nowrap`}
            onClick={() => setRosterFilter('extra')}
          >
            <span className="d-none d-sm-inline">Extra</span>
            <span className="d-inline d-sm-none"><i className="bi bi-star-fill"></i></span>
          </button>
        </div>
          */}

        {/* FILTRI TIPO (con stile brand) */}
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-2">
          <div className="btn-group btn-group-sm shows-filter-group">
            <button
              className={`btn shows-filter-btn ${typeFilter === 'all' ? 'btn-brand-primary' : 'btn-outline-brand-primary'}`}
              onClick={() => setTypeFilter('all')}
            >
              <span className="d-none d-sm-inline">Tutti</span>
              <span className="d-inline d-sm-none"><i className="bi bi-filter" /></span>
            </button>
            <button
              className={`btn shows-filter-btn ${typeFilter === 'weekly' ? 'btn-brand-primary' : 'btn-outline-brand-primary'}`}
              onClick={() => setTypeFilter('weekly')}
            >
              <span className="d-none d-sm-inline">Settimanali</span>
              <span className="d-inline d-sm-none"><i className="bi bi-calendar-week" /></span>
            </button>
            <button
              className={`btn shows-filter-btn ${typeFilter === 'ple' ? 'btn-brand-secondary' : 'btn-outline-brand-secondary'}`}
              onClick={() => setTypeFilter('ple')}
            >
              <span className="d-none d-sm-inline">PLE</span>
              <span className="d-inline d-sm-none"><i className="bi bi-award" /></span>
            </button>
            <button
              className={`btn shows-filter-btn ${rosterFilter === 'extra' ? 'btn-brand-accent' : 'btn-outline-brand-accent'}`}
              onClick={() => setRosterFilter(prev => prev === 'extra' ? 'all' : 'extra')}
            >
              <span className="d-none d-sm-inline">Extra</span>
              <span className="d-inline d-sm-none"><i className="bi bi-stars" /></span>
            </button>
          </div>
        </div>

        {/* CONTENUTO PRINCIPALE (SOLO GRIGLIA) */}
        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-brand-secondary" role="status">
              <span className="visually-hidden">Caricamento...</span>
            </div>
          </div>
        ) : filteredShows.length === 0 ? (
          <div className="text-center py-5">
            <i className="bi bi-calendar-x fs-1 text-muted-brand mb-3" />
            <p className="text-muted-brand">Nessuno show in programma</p>
          </div>
        ) : (
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-3">
            {filteredShows.map(show => (
              <div key={show.id} className="col">
                <Link
                  to={`/shows/${show.id}`}
                  className="card show-card h-100 text-decoration-none"
                  style={{
                    background: 'linear-gradient(180deg, rgba(18, 24, 31, 0.98), rgba(28, 38, 49, 0.96))',
                    boxShadow: '0 14px 30px rgba(0, 0, 0, 0.28)',
                    borderRadius: 'var(--border-radius)',
                    border: '1px solid rgba(146, 201, 252, 0.12)',
                    transition: 'var(--transition)'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-4px)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                >
                  <div
                    className="card-img-top position-relative"
                    style={{
                      height: '150px',
                      backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${show.sfondo})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center'
                    }}
                  >
                    {/* Logo centrato */}
                    {show.logo && (
                      <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center p-3">
                        <img
                          src={show.logo}
                          alt={show.nome}
                          className="img-fluid h-100 w-auto"
                          style={{
                            objectFit: 'contain',
                            maxHeight: '80%',
                            maxWidth: '80%'
                          }}
                        />
                      </div>
                    )}

                    {/* Badge tipo in alto a destra */}
                    <div style={{ position: 'absolute', top: '10px', right: '10px' }}>
                      {getTypeBadge(show.type)}
                    </div>

                    {/* Badge roster (extra) */}
                    {show.roster === 'extra' && (
                      <span
                        className="position-absolute top-0 start-0 m-2 badge"
                        style={{
                          background: 'var(--brand-accent)',
                          color: 'white'
                        }}
                      >
                        Extra
                      </span>
                    )}

                    {/* Data in basso a sinistra */}
                    <small className="position-absolute bottom-0 start-0 m-1 badge" style={{
                      background: 'transparent',
                      fontSize: '0.7rem',
                      color: 'white'
                    }}>
                      <i className="bi bi-calendar-event me-1" />
                      {show.date?.toLocaleDateString('it-IT') || 'N/D'}
                    </small>

                    {/* Partecipanti in basso a destra */}
                    <small className="position-absolute bottom-0 end-0 m-1 badge" style={{
                      background: 'transparent',
                      fontSize: '0.7rem',
                      color: 'white'
                    }}>
                      <i className="bi bi-people me-1" />
                      {show.participantsCount || 0}
                    </small>
                  </div>

                  <div className="card-body" style={{ color: 'white' }}>
                    <div className="d-flex justify-content-between align-items-start gap-2 mb-2">
                      <h6 className="mb-0 fw-bold text-light">{show.nome}</h6>
                      <span
                        className="badge"
                        style={{
                          background: show.roster === 'extra' ? 'rgba(198, 34, 46, 0.18)' : 'rgba(146, 201, 252, 0.12)',
                          color: show.roster === 'extra' ? '#ff9aa2' : 'var(--brand-primary-ultralight)',
                          border: show.roster === 'extra' ? '1px solid rgba(198, 34, 46, 0.4)' : '1px solid rgba(146, 201, 252, 0.28)'
                        }}
                      >
                        {show.roster === 'extra' ? 'NXT/Extra' : 'Main Roster'}
                      </span>
                    </div>
                    <div className="small text-muted-brand d-flex justify-content-between">
                      <span>{show.date?.toLocaleDateString('it-IT') || 'N/D'}</span>
                      <span>{show.participantsCount || 0} wrestler</span>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default NextShows;
